
import Vue from 'vue';

interface Props {
  labels: string[];
  paid: boolean;
  pill: boolean;
}

export default Vue.extend<unknown, unknown, unknown, Props>({
  name: 'HeadlineLabels',
  props: {
    labels: {
      type: Array,
      required: true,
    },
    paid: {
      type: Boolean,
      default: false,
      required: false,
    },
    pill: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
});
